
export default {
  name: 'Panel',

  props: {
    extraPadding: {
      type: Boolean,
      default: false
    },

    transparent: {
      type: Boolean,
      default: false
    },

    isFlat: {
      type: Boolean,
      default: false
    },

    hasPadding: {
      type: Boolean,
      default: true
    },

    isRounded: {
      type: Boolean,
      default: true
    },

    color: {
      type: String,
      default: null,
      validator: prop => ['gray', 'red', 'yellow', 'green', 'blue', 'indigo', 'purple'].includes(prop)
    }
  },

  computed: {
    compSlotClasses() {
      if (!this.hasPadding) {
        return ''
      } else {
        let classes = this.extraPadding ? 'py-6 px-8' : 'md:px-6 px-4 py-4'

        if (this.color) {
          classes += ' ml-1 md:ml-0'
        }

        return classes
      }
    }
  }
}
